import { MHTTPCL,HttpClient, JSON_STRING, clientName, baseUrl } from "../../../services/http/http-client";
import { MODIFICATION_URL } from "../../booking/services/booking-service";
import { CONTACTS_URL } from "../../contacts/services/contact_groups.service";
import { combineServiceMethods } from "../../../global/service";

export const ACCOUNTING_URL = '/accounting.pl';

export const InvoiceForwardService = {

  
    getIvoiceDetails: (invoice_id) => MHTTPCL.post(ACCOUNTING_URL, {
        section: 'invoices',
        action:'invoice_tab_forwarding',
        invoice_id:invoice_id,

        output: JSON_STRING
      }),

  postDealMemo: (calendar_date_id,first_offer_notes) => MHTTPCL.post(ACCOUNTING_URL, {
    section: 'invoices',
    action:'save_first_offer_notes',
    calendar_date_id:calendar_date_id,
    first_offer_notes:first_offer_notes,
    output: JSON_STRING
  }),
  postArtistPayments:(invoice_id,recipient) => MHTTPCL.post(ACCOUNTING_URL, {
    section: 'invoices',
    action:'add_artist_payment_forward',
    invoice_id:invoice_id,
    recipient:recipient,
    output: JSON_STRING
  }),


  updateArtistpayments:(payment_id,value,name) => MHTTPCL.post(MODIFICATION_URL, {
    key: 'payment_id',
    kVal:payment_id,
    name:name,
    value:value,
    table: 'payments'
  }),

  deleteArtistPayments:(payment_id)=>MHTTPCL.post(ACCOUNTING_URL, {
    section: 'invoices',
    action:'delete_payment',
    payment_id:payment_id

  }),
  postForwardCompletedFlag:(kVal,val)=>MHTTPCL.modify("invoice_id",kVal,"forward_completed_flag",val,"invoices"),
  
  // post(MODIFICATION_URL,{
  //    key:"invoice_id",
  //   KEYVAL:kVal,
  //   // name:"forward_completed_flag",
  //   value:val,
  //   table:"invoices",
    
  // }),



  getInvoiceTabForward:(invoice_id)=>MHTTPCL.post(ACCOUNTING_URL,{
    section:"invoices",
    action:"invoice_tab_forwarding",
    invoice_id:invoice_id
  })


}